// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1XIrK","choiceBoxes":"toolbarselects_choiceBoxes__1RpMY","simpleField":"toolbarselects_simpleField__3swLR"};